export default {"src":"/_next/static/media/app-footer-absctraction.90e09457.svg","height":65,"width":328,"blurWidth":0,"blurHeight":0};